import { render } from "./TrainInformation.html?vue&type=template&id=8fa85722&ts=true&external"
import script from "./TrainInformation.vue?vue&type=script&lang=ts"
export * from "./TrainInformation.vue?vue&type=script&lang=ts"

import "./TrainInformation.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__